<template>
  <div class="vehicle-detail-container">
    <!-- 顶部导航栏 -->
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
        <span class="page-title">车辆详情</span>
      </div>
      <div class="header-right">
        <!-- <el-button 
          type="primary" 
          size="small" 
          icon="el-icon-edit" 
          @click="goEdit" 
          v-if="vehicleInfo && vehicleInfo.id"
        >编辑</el-button> -->
        <el-button 
          type="success" 
          size="small" 
          icon="el-icon-refresh-right" 
          @click="fetchVehicleDetail"
          :loading="loading"
        >刷新</el-button>
      </div>
    </div>

    <!-- 主要内容区 -->
    <el-card class="detail-card" v-loading="loading" shadow="hover">
      <!-- 基本信息卡片 -->
      <div v-if="vehicleInfo" class="vehicle-content">
        <!-- 车辆状态横幅 -->
        <div class="status-banner" :class="vehicleInfo.isValid ? 'status-active' : 'status-inactive'">
          <div class="status-icon">
            <i :class="vehicleInfo.isValid ? 'el-icon-check' : 'el-icon-close'"></i>
          </div>
          <div class="status-text">
            <span class="status-label">当前状态</span>
            <span class="status-value">{{ vehicleInfo.isValid ? '有效' : '无效' }}</span>
          </div>
          <div class="status-actions">
            <el-tag :type="getInsuranceStatus(vehicleInfo.commercialInsuranceExpireDate)" size="small">
              商业险 {{ getDaysRemaining(vehicleInfo.commercialInsuranceExpireDate) }}
            </el-tag>
            <el-tag :type="getInsuranceStatus(vehicleInfo.compulsoryInsuranceExpireDate)" size="small">
              交强险 {{ getDaysRemaining(vehicleInfo.compulsoryInsuranceExpireDate) }}
            </el-tag>
          </div>
        </div>

        <!-- 关键信息卡片 -->
        <div class="info-cards">
          <div class="info-card">
            <div class="card-icon">
              <i class="el-icon-truck"></i>
            </div>
            <div class="card-content">
              <div class="card-label">车牌号</div>
              <div class="card-value">{{ vehicleInfo.plateNumber }}</div>
            </div>
          </div>
          <div class="info-card">
            <div class="card-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="card-content">
              <div class="card-label">驾驶员</div>
              <div class="card-value">{{ vehicleInfo.driverName || '—' }}</div>
            </div>
          </div>
          <div class="info-card">
            <div class="card-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <div class="card-content">
              <div class="card-label">车主</div>
              <div class="card-value">{{ vehicleInfo.vehicleOwner || '—' }}</div>
            </div>
          </div>
          <div class="info-card">
            <div class="card-icon">
              <i class="el-icon-phone"></i>
            </div>
            <div class="card-content">
              <div class="card-label">联系方式</div>
              <div class="card-value">{{ vehicleInfo.responsiblePersonPhone || '—' }}</div>
            </div>
          </div>
        </div>

        <!-- 基本信息 -->
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-info"></i>
              <span>基本信息</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="info-grid">
            <div class="info-row">
              <span class="info-label">车辆ID</span>
              <span class="info-value">{{ vehicleInfo.id }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">车辆性质</span>
              <span class="info-value">{{ vehicleInfo.vehicleNatureName || vehicleInfo.vehicleNature || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">车型</span>
              <span class="info-value">{{ vehicleInfo.vehicleModel || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">车辆归属</span>
              <span class="info-value">{{ vehicleInfo.vehicleOwnership || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">档案编号</span>
              <span class="info-value">{{ vehicleInfo.archiveNumber || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">车辆识别码(VIN)</span>
              <span class="info-value">{{ vehicleInfo.vin || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">注册日期</span>
              <span class="info-value">{{ vehicleInfo.registrationDate | formatDate }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">上牌日期</span>
              <span class="info-value">{{ vehicleInfo.licensePlateDate | formatDate }}</span>
            </div>
          </div>
        </div>

        <!-- 技术参数 -->
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-s-tools"></i>
              <span>技术参数</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="info-grid">
            <div class="info-row">
              <span class="info-label">轴数</span>
              <span class="info-value">{{ vehicleInfo.axleCount }} 个</span>
            </div>
            <div class="info-row">
              <span class="info-label">核定载重</span>
              <span class="info-value">{{ vehicleInfo.ratedLoad }} 吨</span>
            </div>
            <div class="info-row">
              <span class="info-label">装载件数</span>
              <span class="info-value">{{ vehicleInfo.loadCapacity }} 件</span>
            </div>
            <div class="info-row">
              <span class="info-label">箱体尺寸</span>
              <span class="info-value">{{ vehicleInfo.boxSize || '—' }}</span>
            </div>
          </div>
        </div>

        <!-- 证照有效期 -->
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-document-copy"></i>
              <span>证照有效期</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="expiry-grid">
            <div class="expiry-item" :class="getExpiryClass(vehicleInfo.drivingLicenseExpireDate)">
              <div class="expiry-label">行驶证有效期</div>
              <div class="expiry-value">{{ vehicleInfo.drivingLicenseExpireDate | formatDate }}</div>
              <div class="expiry-badge">{{ getDaysRemaining(vehicleInfo.drivingLicenseExpireDate) }}</div>
            </div>
            <div class="expiry-item" :class="getExpiryClass(vehicleInfo.operatingPermitExpireDate)">
              <div class="expiry-label">营运证有效期</div>
              <div class="expiry-value">{{ vehicleInfo.operatingPermitExpireDate | formatDate }}</div>
              <div class="expiry-badge">{{ getDaysRemaining(vehicleInfo.operatingPermitExpireDate) }}</div>
            </div>
            <div class="expiry-item" :class="getExpiryClass(vehicleInfo.internalExpireDate)">
              <div class="expiry-label">中烟内部到期日</div>
              <div class="expiry-value">{{ vehicleInfo.internalExpireDate | formatDate }}</div>
              <div class="expiry-badge">{{ getDaysRemaining(vehicleInfo.internalExpireDate) }}</div>
            </div>
          </div>
        </div>

        <!-- 保险信息 -->
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-s-finance"></i>
              <span>保险信息</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="insurance-grid">
            <div class="insurance-card" :class="getInsuranceClass(vehicleInfo.compulsoryInsuranceExpireDate)">
              <div class="insurance-icon">
                <i class="el-icon-shield"></i>
              </div>
              <div class="insurance-info">
                <div class="insurance-name">交强险</div>
                <div class="insurance-date">{{ vehicleInfo.compulsoryInsuranceExpireDate | formatDate }}</div>
                <div class="insurance-remaining">{{ getDaysRemaining(vehicleInfo.compulsoryInsuranceExpireDate) }}</div>
              </div>
            </div>
            <div class="insurance-card" :class="getInsuranceClass(vehicleInfo.commercialInsuranceExpireDate)">
              <div class="insurance-icon">
                <i class="el-icon-s-claim"></i>
              </div>
              <div class="insurance-info">
                <div class="insurance-name">商业险</div>
                <div class="insurance-date">{{ vehicleInfo.commercialInsuranceExpireDate | formatDate }}</div>
                <div class="insurance-remaining">{{ getDaysRemaining(vehicleInfo.commercialInsuranceExpireDate) }}</div>
              </div>
            </div>
            <div class="insurance-card" :class="getInsuranceClass(vehicleInfo.cargoInsuranceExpireDate)">
              <div class="insurance-icon">
                <i class="el-icon-box"></i>
              </div>
              <div class="insurance-info">
                <div class="insurance-name">货物险</div>
                <div class="insurance-date">{{ vehicleInfo.cargoInsuranceExpireDate | formatDate }}</div>
                <div class="insurance-remaining">{{ getDaysRemaining(vehicleInfo.cargoInsuranceExpireDate) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 维保信息 -->
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-setting"></i>
              <span>维保信息</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="maintenance-grid">
            <div class="maintenance-item">
              <div class="maintenance-label">
                <i class="el-icon-date"></i> 保养日期
              </div>
              <div class="maintenance-value">{{ vehicleInfo.maintenanceDate | formatDate }}</div>
            </div>
            <div class="maintenance-item">
              <div class="maintenance-label">
                <i class="el-icon-odometer"></i> 保养里程
              </div>
              <div class="maintenance-value">{{ vehicleInfo.maintenanceMileage }} 公里</div>
            </div>
            <div class="maintenance-item">
              <div class="maintenance-label">
                <i class="el-icon-warning"></i> 安全检查到期日
              </div>
              <div class="maintenance-value">{{ vehicleInfo.vehicleInspectionExpireDate | formatDate }}</div>
            </div>
            <div class="maintenance-item">
              <div class="maintenance-label">
                <i class="el-icon-timer"></i> GPS有效期
              </div>
              <div class="maintenance-value">{{ vehicleInfo.gpsExpireDate | formatDate }}</div>
            </div>
            <div class="maintenance-item">
              <div class="maintenance-label">
                <i class="el-icon-fire-extinguisher"></i> 灭火器到期日
              </div>
              <div class="maintenance-value">{{ vehicleInfo.fireExtinguisherExpireDate | formatDate }}</div>
            </div>
            <div class="maintenance-item full-width">
              <div class="maintenance-label">
                <i class="el-icon-document"></i> 保养项目
              </div>
              <div class="maintenance-value">{{ vehicleInfo.maintenanceItems || '—' }}</div>
            </div>
          </div>
        </div>

        <!-- 备注信息 -->
        <div class="section" v-if="vehicleInfo.remark">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-chat-line-square"></i>
              <span>备注信息</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="remark-content">
            {{ vehicleInfo.remark }}
          </div>
        </div>

        <!-- 车辆照片 -->
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-picture-outline"></i>
              <span>车辆照片</span>
            </div>
            <div class="section-line"></div>
          </div>
          <div class="photo-gallery">
            <div class="photo-card" v-if="vehicleInfo.frontPhotoUrl">
              <div class="photo-card-header">
                <i class="el-icon-camera"></i>
                <span>正面照片</span>
              </div>
              <ImageViewer :src="vehicleInfo.frontPhotoUrl" class="photo-image" />
            </div>
            <div class="photo-card" v-if="vehicleInfo.compartment45PhotoUrl">
              <div class="photo-card-header">
                <i class="el-icon-camera"></i>
                <span>45度角照片</span>
              </div>
              <ImageViewer :src="vehicleInfo.compartment45PhotoUrl" class="photo-image" />
            </div>
            <div class="photo-card" v-if="vehicleInfo.vehiclePhotoUrl">
              <div class="photo-card-header">
                <i class="el-icon-camera"></i>
                <span>车辆照片</span>
              </div>
              <ImageViewer :src="vehicleInfo.vehiclePhotoUrl" multiple class="photo-image" />
            </div>
            <div class="photo-card" v-if="vehicleInfo.otherPhotoUrl && parseOtherPhotos(vehicleInfo.otherPhotoUrl).length > 0">
              <div class="photo-card-header">
                <i class="el-icon-camera"></i>
                <span>其他照片</span>
              </div>
              <div class="photo-grid">
                <ImageViewer 
                  v-for="(url, index) in parseOtherPhotos(vehicleInfo.otherPhotoUrl)" 
                  :key="index"
                  :src="url" 
                  class="photo-image" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!loading" class="empty-tip">
        <el-empty description="未找到车辆信息">
          <el-button type="primary" size="small" @click="fetchVehicleDetail">重新加载</el-button>
        </el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '@/utils/api'
import ImageViewer from '@/components/ImageViewer.vue'

export default {
  name: 'VehicleDetail',
  components: {
    ImageViewer
  },
  data() {
    return {
      loading: false,
      vehicleInfo: null
    }
  },
  filters: {
    formatDate(val) {
      if (!val) return '—'
      return val.split('T')[0]
    }
  },
  created() {
    this.fetchVehicleDetail()
  },
  methods: {
    parseOtherPhotos(otherPhotoUrl) {
      if (!otherPhotoUrl) return []
      try {
        let parsed = JSON.parse(otherPhotoUrl)
        // 如果解析后还是字符串，说明是双重转义，需要再次解析
        if (typeof parsed === 'string') {
          parsed = JSON.parse(parsed)
        }
        return Object.values(parsed).filter(Boolean)
      } catch (e) {
        console.error('解析 otherPhotoUrl 失败:', e)
        return []
      }
    },
    fetchVehicleDetail() {
      const id = this.$route.query.id
      if (!id) {
        this.$message.error('缺少车辆ID参数')
        return
      }
      this.loading = true
      api.get(`/api/Vehicles/${id}`)
        .then(res => {
          this.vehicleInfo = res.data
        })
        .catch(err => {
          this.$message.error('获取车辆详情失败')
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDaysRemaining(dateStr) {
      if (!dateStr) return '未设置'
      const expireDate = new Date(dateStr.split('T')[0])
      const today = new Date()
      const diffDays = Math.ceil((expireDate - today) / (1000 * 60 * 60 * 24))
      if (diffDays < 0) return '已过期'
      if (diffDays === 0) return '今日到期'
      return `${diffDays}天后到期`
    },
    getExpiryClass(dateStr) {
      if (!dateStr) return ''
      const expireDate = new Date(dateStr.split('T')[0])
      const today = new Date()
      const diffDays = Math.ceil((expireDate - today) / (1000 * 60 * 60 * 24))
      if (diffDays < 0) return 'expiry-expired'
      if (diffDays <= 30) return 'expiry-warning'
      return ''
    },
    getInsuranceStatus(dateStr) {
      if (!dateStr) return 'info'
      const expireDate = new Date(dateStr.split('T')[0])
      const today = new Date()
      const diffDays = Math.ceil((expireDate - today) / (1000 * 60 * 60 * 24))
      if (diffDays < 0) return 'danger'
      if (diffDays <= 30) return 'warning'
      return 'success'
    },
    getInsuranceClass(dateStr) {
      if (!dateStr) return ''
      const expireDate = new Date(dateStr.split('T')[0])
      const today = new Date()
      const diffDays = Math.ceil((expireDate - today) / (1000 * 60 * 60 * 24))
      if (diffDays < 0) return 'insurance-expired'
      if (diffDays <= 30) return 'insurance-warning'
      return ''
    },
    goBack() {
      this.$router.go(-1)
    },
    goEdit() {
      this.$router.push({
        path: '/vehicles',
        query: { editId: this.vehicleInfo.id }
      })
    }
  }
}
</script>

<style scoped>
.vehicle-detail-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

/* 页面头部 */
.page-header {
  max-width: 1400px;
  margin: 0 auto 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  gap: 12px;
}

/* 卡片样式 */
.detail-card {
  max-width: 1400px;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.2);
}

.vehicle-content {
  padding: 0 8px;
}

/* 状态横幅 */
.status-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}

.status-active {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
}

.status-inactive {
  background: linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%);
}

.status-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-icon i {
  font-size: 24px;
}

.status-text {
  flex: 1;
  margin-left: 16px;
}

.status-label {
  font-size: 13px;
  opacity: 0.9;
  display: block;
}

.status-value {
  font-size: 18px;
  font-weight: 700;
}

.status-actions {
  display: flex;
  gap: 12px;
}

/* 关键信息卡片 */
.info-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.info-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.3s ease;
  border: 1px solid #e8eaed;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
}

.card-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon i {
  font-size: 24px;
  color: #fff;
}

.card-content {
  flex: 1;
}

.card-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}

.card-value {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

/* 区块样式 */
.section {
  margin-top: 32px;
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.section-title i {
  font-size: 20px;
  color: #667eea;
}

.section-line {
  height: 3px;
  width: 50px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px;
}

/* 信息网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.info-row {
  display: flex;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.info-row:hover {
  background: #f0f2f5;
}

.info-label {
  width: 120px;
  font-size: 13px;
  color: #909399;
}

.info-value {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

/* 证照网格 */
.expiry-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.expiry-item {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
}

.expiry-item.expiry-warning {
  background: #fff7e6;
  border-left: 3px solid #fa8c16;
}

.expiry-item.expiry-expired {
  background: #fff1f0;
  border-left: 3px solid #f5222d;
}

.expiry-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.expiry-value {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.expiry-badge {
  display: inline-block;
  padding: 2px 8px;
  background: #fff;
  border-radius: 12px;
  font-size: 12px;
  color: #606266;
}

.expiry-warning .expiry-badge {
  background: #fa8c16;
  color: #fff;
}

.expiry-expired .expiry-badge {
  background: #f5222d;
  color: #fff;
}

/* 保险网格 */
.insurance-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.insurance-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.3s ease;
}

.insurance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.insurance-card.insurance-warning {
  background: #fff7e6;
}

.insurance-card.insurance-expired {
  background: #fff1f0;
}

.insurance-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.insurance-icon i {
  font-size: 22px;
  color: #fff;
}

.insurance-warning .insurance-icon {
  background: linear-gradient(135deg, #fa8c16 0%, #d46b08 100%);
}

.insurance-expired .insurance-icon {
  background: linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%);
}

.insurance-info {
  flex: 1;
}

.insurance-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.insurance-date {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.insurance-remaining {
  font-size: 11px;
  color: #667eea;
}

.insurance-warning .insurance-remaining {
  color: #fa8c16;
}

.insurance-expired .insurance-remaining {
  color: #f5222d;
}

/* 维保信息 */
.maintenance-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.maintenance-item {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.maintenance-item.full-width {
  grid-column: span 2;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.maintenance-label {
  font-size: 13px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 6px;
}

.maintenance-label i {
  font-size: 14px;
}

.maintenance-value {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

/* 备注内容 */
.remark-content {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

/* 照片画廊 */
.photo-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.photo-card {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e8eaed;
}

.photo-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.photo-card-header {
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.photo-card-header i {
  font-size: 16px;
}

.photo-image {
  width: 100%;
  min-height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
}

/* 照片网格横向布局 */
.photo-grid {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px;
  padding: 12px 16px;
}

.photo-grid .photo-image {
  width: 180px !important;
  height: 120px !important;
  flex-shrink: 0;
}

/* 空状态 */
.empty-tip {
  text-align: center;
  padding: 60px 0;
}

/* 响应式 */
@media (max-width: 1024px) {
  .info-cards,
  .expiry-grid,
  .insurance-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 16px;
  }
  
  .info-cards,
  .expiry-grid,
  .insurance-grid,
  .maintenance-grid {
    grid-template-columns: 1fr;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .maintenance-item.full-width {
    grid-column: span 1;
  }
  
  .status-banner {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .status-actions {
    justify-content: center;
  }
  
  .photo-gallery {
    grid-template-columns: 1fr;
  }
}
</style>